// utils/dataProcessing.ts
import { titularSchema, dependenteSchema } from '../schemas/beneficiarySchema';

export const Planos = [
  { id: 502863255, nome: 'One BSB Enfermaria', tipo: 1 },
  { id: 502863259, nome: 'One BSB Apartamento', tipo: 1 },
  { id: 500346246, nome: 'Now CA CP Enfermaria', tipo: 2 },
  { id: 500346248, nome: 'Now CA CP Apartamento', tipo: 2 },
  { id: 504242259, nome: 'Evo Now DF CA Enfermaria', tipo: 2 },
  { id: 504241251, nome: 'Evo Now DF CA Apartamento', tipo: 2 },
];

export function mascaraCPF(cpf: string): string {
  cpf = String(cpf).replace(/\D/g, '');
  if (cpf.length !== 11) return cpf;
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function mascaraTelefone(numero: string): string {
  numero = String(numero).replace(/\D/g, '');

  if (numero.length === 10) {
    return numero.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else if (numero.length === 11) {
    return numero.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  } else {
    return numero;
  }
}
function excelDateToJSDate(serial: number): string {
  // Excel bug: 1900 is not a leap year, so we need to adjust for dates >= 60
  const excelEpoch = new Date(Date.UTC(1899, 11, 30));
  let days = serial;

  if (days > 59) days += 1; // Excel bug: skips 29/02/1900

  const date = new Date(excelEpoch.getTime() + days * 24 * 60 * 60 * 1000);
  const dia = String(date.getDate()).padStart(2, '0');
  const mes = String(date.getMonth() + 1).padStart(2, '0');
  const ano = date.getFullYear();
  return `${dia}/${mes}/${ano}`;
}

export function agruparTitularesEDependentes(
  data: any[],
  setHasPlanoOne: (value: boolean) => void,
  setHasPlanoNow: (value: boolean) => void,
): any[] {
  const titulares: any[] = [];
  let titularId = 0;
  let genericTitular = null;
  data.forEach(row => {
    if (
      ((!row.PARENT || row.PARENT === 'T') && !row['Matricula Empresa']) ||
      (row['Tipo Registro'] && row['Tipo Registro'] === 'T')
    ) {
      const dataNascimento = row.DT_NASC
        ? typeof row.DT_NASC === 'number'
          ? String(excelDateToJSDate(row.DT_NASC))
          : String(row.DT_NASC)
        : excelDateToJSDate(row['Dt Nascimento']);
      const titular = {
        id: String(titularId++),
        matriculaEmpresa: row['Matricula Empresa'] || '',
        cnpj: row['CNPJ Vinculo Contratante'] || '',
        cpf: row.CPF
          ? String(row.CPF).replace(/\D/g, '').padStart(11, '0')
          : '',
        nome: row.NOME || row['Nome'] || '',
        plano: row.COD_PLANO ? String(row.COD_PLANO) : '502863255',
        OrgaoExp: row.ORG_EXP || 'SSP',
        cns: String(row.CNS) || String(row['Cartão SUS']) || '',
        dataNascimento: dataNascimento,
        sexo: row.SEXO || row.Sexo || '',
        estCivil: row.EST_CIVIL
          ? String(row.EST_CIVIL)
          : row['Estado Civil']
          ? String(row['Estado Civil'])
          : '0',
        endereco: {
          cep: row.CEP ? String(row.CEP) : row['Cep'] ? String(row['Cep']) : '',
          bairro: row.BAIRRO || '',
          uf: row.UF || '',
          cidade: row.CIDADE || '',
          logradouro: row.LOGRADOURO || '',
          numero: row.NUMERO
            ? String(row.NUMERO)
            : row['Numero']
            ? String(row['Numero'])
            : '0',
          complemento: row.COMPLEMENTO || row.Complemento || '',
        },
        celular:
          (row.DDD_CEL
            ? String(row.DDD_CEL)
            : row['DDD Fone']
            ? String(Number(row['DDD Fone']))
            : '') +
          (row.CEL
            ? String(row.CEL)
            : row['Telefone 1']
            ? String(row['Telefone 1'])
            : ''),
        telefone1:
          (row.DDD_TEL ? String(row.DDD_TEL) : '') +
          (row.TEL ? String(row.TEL) : ''),
        telefone2:
          (row.DDD_TEL_2 ? String(row.DDD_TEL_2) : '') +
          (row.TEL_2 ? String(row.TEL_2) : ''),
        nomeMae: row.NOME_MAE || row['Nome Mãe'] || '',
        email: row.EMAIL || '',
        dependentes: [],
      };

      if (Planos.find(p => String(p.id) === titular.plano)?.tipo === 1) {
        setHasPlanoOne(true);
      } else {
        setHasPlanoNow(true);
      }

      try {
        titularSchema.parse(titular);
        titulares.push(titular);
      } catch (err) {
        console.error('Erro de validação no titular:', row.CPF, err);
      }
    } else {
      const titular = titulares.find(
        t =>
          t.cpf === String(row.COD_RESP).replace(/\D/g, '') ||
          t.matriculaEmpresa === row['Matricula Empresa'],
      );

      const dataNascimento = row.DT_NASC
        ? typeof row.DT_NASC === 'number'
          ? String(excelDateToJSDate(row.DT_NASC))
          : String(row.DT_NASC)
        : excelDateToJSDate(row['Dt Nascimento']);

      const dependente = {
        id: String(
          titular
            ? titular.dependentes.length
            : genericTitular
            ? genericTitular.dependentes.length
            : 0,
        ),
        cpf: row.CPF
          ? String(row.CPF).replace(/\D/g, '').padStart(11, '0')
          : '',
        nome: row.NOME || row['Nome'] || '',
        dataNascimento,
        nomeMae: row.NOME_MAE || row['Nome Mãe'] || '',
        cns: String(row.CNS) || String(row['Cartão SUS']) || '',
        sexo: row.SEXO || row.Sexo || '',
        estCivil: row.EST_CIVIL
          ? String(row.EST_CIVIL)
          : row['Estado Civil']
          ? String(row['Estado Civil'])
          : '0',
        parentesco: String(row.PARENT) || row['Grau Parentesco'] || '',
        cpfTitular: String(row.COD_RESP).replace(/\D/g, '') || '',
      };

      try {
        dependenteSchema.parse(dependente);
      } catch (err) {
        console.error('Erro de validação no dependente:', row.CPF, err);
      }

      if (!titular) {
        if (!genericTitular) {
          genericTitular = {
            id: String(titularId++),
            matriculaEmpresa: '0000',
            cnpj: '',
            cpf: '00000000000',
            nome: 'TITULAR NÃO ENCONTRADO',
            plano: '502863255',
            OrgaoExp: 'SSP',
            cns: '',
            dataNascimento: '',
            sexo: '',
            estCivil: '0',
            endereco: {
              cep: '',
              bairro: '',
              uf: '',
              cidade: '',
              logradouro: '',
              numero: '0',
              complemento: '',
            },
            celular: '',
            telefone1: '',
            telefone2: '',
            nomeMae: '',
            email: '',
            dependentes: [],
          };

          titulares.push(genericTitular);
          console.warn('Criado titular genérico para dependentes órfãos');
        }

        genericTitular.dependentes.push(dependente);
      } else {
        titular.dependentes.push(dependente);
      }
    }
  });
  return titulares;
}

export const chunkArray = <T>(array: T[], size: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

export function formatCPF(cpf: string): string {
  if (!cpf) return '';
  const cleaned = cpf.replace(/\D/g, '');
  return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function formatPhoneNumber(numero: string): string {
  if (!numero) return '';
  const cleaned = numero.replace(/\D/g, '');

  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else if (cleaned.length === 11) {
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  return numero;
}
